import React from 'react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { TomoItem } from './TomoItem';
import { tomos } from '../data/tomos';
export function TomosSection() {
  return <section id="tomos" className="bg-mp-black py-20 md:py-28" data-id="element-394" data-mp="1p4lij4zavhpu">
      <Container data-id="element-395" data-mp="1u2dk6qpqyi78">
        <div className="max-w-[700px]" data-id="element-396" data-mp="1u2wqtb9y5k5y">
          <SectionTag tone="lime" data-id="element-397" data-mp="1u1ve72da8pm4">La colección principal</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-398" data-mp="xdfpf8hzyka2">
            5 tomos. Un solo sistema.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-399" data-mp="16dc7gr9vskw5">
            Desde los fundamentos técnicos hasta la gestión profesional de una escuela de pádel.
          </p>
        </div>

        <div className="mt-16 space-y-16 md:mt-20 md:space-y-0" data-id="element-400" data-mp="2hshjwmztdxsy">
          {tomos.map((tomo, index) => <TomoItem key={tomo.number} tomo={tomo} reverse={index % 2 === 1} data-id="element-401" data-mp="2mqsu4yu0uabp" data-mpi={index} />)}
        </div>
      </Container>
    </section>;
}